import styled from 'styled-components'
import { dangerHover, black, textMuted, grey } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'

export const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 48px 24px;
	text-align: center;
`

export const Title = styled.h2`
	margin: 0;
	${text.title}
	color: ${black};
`

export const Message = styled.p`
	margin: 0;
	max-width: 420px;
	font-size: ${fontSizes.small};
	line-height: ${leading.body};
	color: ${textMuted};
`

export const Actions = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 8px;
`

export const RetryButton = styled(Button)``

export const SecondaryButton = styled(Button).attrs({ variant: 'secondary' as const })``

/** Only rendered outside production, where the raw message is useful. */
export const Details = styled.pre`
	max-width: 100%;
	margin: 8px 0 0;
	padding: 12px;
	overflow-x: auto;
	border-radius: ${radii.small};
	background: ${grey};
	color: ${dangerHover};
	font-size: ${fontSizes.micro};
	text-align: left;
	white-space: pre-wrap;
	word-break: break-word;
`
